import FilterSearchURLProvider from './FilterSearchURLProvider';

export default FilterSearchURLProvider;
